import React, { useEffect } from 'react';
import Text from '~components/atoms/Text';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import SerialNumberSearchTable from './SerialNumberSearchTable';

import * as Styles from './_serialNumberSearch.module.scss';
import SerialNumberSearchAndFilterBar from './SerialNumberSearchAndFilterBar';
import SerialNumberSearchTablePaginator from './SerialNumberSearchTablePaginator';
import { useAppSelector } from '~redux/hooks';
import { useDispatch } from 'react-redux';
import combinedActions from '~redux/combinedActions';

const SerialNumberSearch = () => {
    const dispatch = useDispatch();

    const serialNumberListingIndex = useAppSelector(state => state.gold.serialNumber.serialNumberListing.index);

    useEffect(() => {
        dispatch(combinedActions.goldGetSerialNumberListingAttempt());
    }, [serialNumberListingIndex]);

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Serial Number Search'
                    className={Styles.title}
                    isBold
                />

            </TabPageHeaderWrapper>

            <SerialNumberSearchAndFilterBar />

            <SerialNumberSearchTable />

            <SerialNumberSearchTablePaginator />
        </TabPageContainer>
    );
};

export default SerialNumberSearch;
